export const CLIENT_OFFER_CONFIG = {
  // Default offer
  default: {
    title: "🎉 Congratulations!",
    header: "🔥 Special Offer Today For You!",
    description: "✅ Get Upto 20% OFF on your installation service",
    subDescription: "⚡ Instant booking • Hassle-free service",
    buttonText: "👉 Book Now & Save Upto 20%",
    urgencyText: "Hurry! Offer valid only for today.",
    colors: {
      primary: "#FF512F",
      secondary: "#DD2476",
      background: "#fff",
      text: "#000",
    },
    gradient: "linear-gradient(45deg, #FF512F 30%, #DD2476 90%)",
  },
  // AIRTH Offer
  INC119: {
    title: "💨 Breathing Clean Air Is a Reality 🌿",
    header: "💥 Special Discount Just For You!",
    description: "🌱 Use coupon code *ONIT25*",
    subDescription: "🍀 Exclusive Offer from AIRTH",
    buttonText: "👉 Book from www.airth.in",
    urgencyText: "Limited time offer! Don't miss out.",
    colors: {
      primary: "#008184",
      secondary: "#008184",
      background: "#f0f8ff",
      text: "#008184",
    },
    gradient: "linear-gradient(45deg, #008184 30%, #4CAF50 90%)",
  },
  INC123: {
    title: "🎉 Welcome to OniT! 🙏🏻",
    header: "💥  Ab har kaam bahut aasaan!",
    description: "Quick, Reliable, Affordable and Safe Service",
    subDescription:
      "KYC Compliance, Trusted and Certified Service Providers across India.",
    buttonText: "👉 Visit www.onit.services",
    urgencyText: "Digital India Initiative by ADA ENTERPRISES",
    colors: {
      primary: "#003366",
      secondary: "#0A3D91",
      background: "#DCE6F9",
      text: "#002244",
    },
    gradient: "linear-gradient(45deg, #003366 20%, #0A3D91 90%)",
  },
};

// Time Preferences

export const AVAILABLE_TIME_PREFERENCES = [
  { value: "WITHIN_24_HOURS", label: "Within 24 Hours" },
  { value: "SPECIFIC_DATE_AND_TIME", label: "Specific Date & Time" },
];
